import React, { useState } from "react";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import RoomWrapper from "@vonage/video-express/dist/mp/room";
import { IconButton, useMediaQuery, useTheme } from "@material-ui/core";
import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import Tooltip from "@material-ui/core/Tooltip";
import { useStyles } from "./LeaveCallButton.style";
import { Key, removeLocalStorageItem } from "../../../../Utils/LocalStorage";
import { messages } from "./LeaveCallButton.messages";
import AlertDialog from "../../../../Components/Dialogs/AlertDialog/AlertDialog";
import { RoutePath } from "../../../../Components/Routes/RoutePath";

interface Props {
  meetingId: string;
  room: RoomWrapper;
}

export default function LeaveCallButton(props: Props) {
  const { meetingId, room } = props;
  const intl = useIntl();
  const theme = useTheme();
  const classes = useStyles();
  const history = useHistory();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const isPhone = useMediaQuery(theme.breakpoints.down("xs"));

  const redirectToBookingDetails = () => {
    history.push({
      pathname: RoutePath.BOOKING_HISTORY,
      search: `?meetingId=${meetingId}`,
      state: { loadFromMeetingSession: true },
    });
  };

  const handleLeave = () => {
    room.leave().then(() => {
      removeLocalStorageItem(Key.OPENTOK_CLIENT_ID);
      redirectToBookingDetails();
    });
  };

  if (!isPhone) {
    return (
      <>
        <AlertDialog
          open={isDialogOpen}
          title={intl.formatMessage(messages.dialogTitle)}
          submitLabel={intl.formatMessage(messages.dialogSubmitButton)}
          cancelLabel={intl.formatMessage(messages.dialogCancelButton)}
          onSubmit={handleLeave}
          onClose={() => setIsDialogOpen(false)}
        />
        <Tooltip
          title={intl.formatMessage(messages.leaveCallTooltip)}
          aria-label={intl.formatMessage(messages.leaveCallTooltip)}
        >
          <IconButton
            edge="start"
            aria-label={intl.formatMessage(messages.leaveCallTooltip)}
            onClick={() => setIsDialogOpen(true)}
            className={classes.toolbarButtons}
          >
            <ExitToAppIcon fontSize="inherit" />
          </IconButton>
        </Tooltip>
      </>
    );
  }

  return null;
}
